export class Field {
    constructor(
        public name?: string,
        public placeholder?: string,
        public type: string = 'input',
        public color?: string,
        public prefix?: string,
        public suffix?: string,
        public suffixValidation: boolean = false,
        public value?: any,
        public disabled: boolean = false,
        public required: boolean = false,
        public multiple: boolean = false,
        public autocomplete: string = 'true',
        public validators: any[] = [],
        public size: number = 1,
        public items?: any[],
        public valueField?: string,
        public filter?: any,
        public min?: string,
        public max?: string,
        public step?: string,
        public gap?: string,
        public direction?: string,
        public autoUpload: boolean = false,
        public disableMultipart: boolean = false,
        public url?: string,
        public filePath?: string,
        public allowedMimeType?: string[],
        public headers?: any[]
    ) {}
}
